import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Usmeiyan extends Component {
	state={
		youshi:[
			{
				name:'教育质量高，文凭含金量高',
				content:'上千所院校遍布全美，顶级的国际教育标准，世界排名第一、第二的院校都在美国。美国有世界上最先进的科技以及丰富的教育资源，并且拥有开放包容的文化氛围。名校众多：除了全球知名的常青藤盟校之外还有麻省理工、加州理工、斯坦福、加州公立系统下面的大学等等。应该说名校最多的就是美国，如果学生有名校情结，那去美国留学是很好的选择。',
			},
			{
				name:'教育资源丰富，资金充足',
				content:'全美4000余所高校，学校种类丰富，入学形式多样，满足各类学生的留学需求。美国政府极为重视教育，提供丰厚的教育研究经费。美国大学重视人才的吸引和投资，只要在学校表现出色，申请到奖助学金的机会非常大。',
			},
			{
				name:'专业全面，学制灵活',
				content:'美国是一个教育大国，文、理、工、商、艺术五大类的专业非常齐全。美国大部分4年制本科学时的大学，有1-2年的时间考虑专业方向，即使选定后不合适也可以转专业。专业转换灵活可以使得学生在学习过程中调整到更适合自己的专业。本科的时候转学都是比较容易的。并且可以跨专业申请的。工科之间本来就是相互交叉的，所以转起来比较容易。同时理科和工科的学生还可以转专业学习商科等。',
			},
			{
				name:'就业优势',
				content:'美国的校友资源丰富，再加上美国的内推文化，即当一个公司的员工成功推荐新员工入职，原来的员工是可以得到奖金的。因此，在美学生，除了广投简历，通过校友推荐入职也是一个强有力的渠道。\n' +
					'除此之外，中国学生毕业后有一年的OPT从学校过渡到职场。如果申请上STEM专业，则有3年的OPT可以在美工作，积累宝贵的工作经验，回国后市场认知度高，竞争力强，有更多的高薪机会。',
			},
			{
				name:'校园活动丰富，接触多样性文化',
				content:'美国的社会环境自由开放，多种文化民族相互碰撞，相互了解，在这里，你可以开展眼界，更容易接受不同于你的文化，增强包容性。美国大学国际留学生众多，校园活动丰富多彩“多元化”是美国大学非常重视的。',
			},
			{
				name:'提高学习自主性，学术资源丰富',
				content:'在美国，教授不会照本宣科一字一句地喂养式授课。教授更多地是引导学生自主学习。学生需要自己课前看阅读材料，自主完成基础知识的学习，在课上才能和教授进一步进行讨论。课堂外，美国大学的资源优势更为明显。美国越是优秀的大学越是能够提供丰富的学术资源，例如各类讲座、学术会议及交流活动等。',
			},
		],
		zhuanye:[
			{
				title:'金融工程',
				content:'美国金融工程/金融数学专业是一门理、工、商科融合的交叉性专业，其旨在培养学生利用数学和计算机语言方面的知识，来解决金融领域的问题。\n' +
					'金融数学更多的是以高等数学甚至高等微积分为基础，通过复杂的数学算法来完成金融产品的定价过程。金融工程则是以数学和计算机语言为基础，主要研究进入衍生品和固定收益产品（如期权、期货、债券投资等）。',
				img:require('../../static/images/usmeiyan03.png')
			},
			{
				title:'商业分析',
				content:'商业分析是一门近几年才兴起的新学科，是从数据分析出发，以商业知识为基础，以统计和编程为手段，以决策优化来创造价值的新兴专业。该专业的核心是数据分析，通过对公司以往的业绩数据进行深度分析和挖掘、对行业市场潜在的商业信息进行探索等，来获取那些通过定性分析和简单的定量分析无法获得的结论，相比来说，具有更加复杂深入的技术、模型和算法。',
				img:require('../../static/images/usmeiyan04.png')
			},
			{
				title:'会计学',
				content:'在美国，会计硕士研究生专业一般设在商学院，其课程设置一般是12个月，通常学习时间只有九个月，授课内容分为学习和实践两部分，其培养目标学制和课程设置等基本要素实质上都以会计行业的职业要求为主要导向，目标是培养会计实务界，培养应用型的高级人才，美国会计学。',
				img:require('../../static/images/usmeiyan05.png')
			},
			{
				title:'计算机科学',
				content:'计算机科学专业是现在最热门最高薪的专业之一。而美国的计算机专业在技术和产量产业上都是全球领先的，自然也就成了学习计算机最热门的国家。加上计算机专业在美国就业情况很好，进而吸引了很多希望读书后留在美国工作的申请者。<br>' +
					'美国绝大部分学校都开设有计算机科学专业，且该专业基本都开设在工程学院下。',
				img:require('../../static/images/usmeiyan06.png')
			},
			{
				title:'电气与计算机工程',
				content:'在美国很多学校是把EE和CS放在一起的,叫做EECS(电气工程和计算机科学系)。由于美国学校选课通常都比较自由，因此两个专业的课程互选交叉的课程很多，很多教授做的研究既有与CS相关的，也有与EE相关的。EE专业下面有网络方向,CS也有网络工程的方向,EE的信号处理与CS的多媒体等方向有着广泛的交叉。',
				img:require('../../static/images/usmeiyan07.png')
			},
			{
				title:'生物工程',
				content:'通常我们习惯将生物工程（BE）和生物医学工程（BME）混为一谈，事实上从美国大学的院系设置也会看到二者是相通的，研究方向又会有很多重合，只不过院系名称不同而已。但从原则上讲，二者是有区别的，侧重点不同。生物工程是涉及医疗、制药、食品、农业环保、轻工等有关人类衣食住行各个行业的新兴工程领域，是运用生物学、化学和工程学等学科相结合的方法，利用生物体生产人类需要的产品，改造生态系统和环境的应用技术体系。',
				img:require('../../static/images/usmeiyan08.png')
			},
			{
				title:'统计学',
				content:'从美国开设统计学专业的学校来看，统计学大致可以分为两类，一类偏向于理论研究，主要设在统计系或数学系，另一类则偏向于实际应用，如目前非常热门的生物统计、经济统计以及社会统计学等。目前美国统计学主要有四个分支：生物统计、金融统计、应用统计以及数理统计，通常统计学专业开设在美国的数学系下面，有的学校也会设置独立的统计系，由于统计学专业在美国本土就业前景比较乐观，吸引了大批的申请者。专业申请要求申请者有良好的数学基础，并且有一定的计算机操作基础。',
				img:require('../../static/images/usmeiyan09.png')
			},
			{
				title:'传媒学',
				content:'美国是传媒领域的“超级大国”，是最早创立新闻学和传播学专业的国家，拥有全球最发达的传媒系统，美国是世界上最大的电影市场，同时又是最大的电影出口国，并且控制了全球录音产品市场38%的份额，有四大商业性广播网（ABC、CBS、MBC、NBC）。总而言之是传媒人士向往的镀金圣地。\n' +
					'传媒专业有很多的分支：新闻、广告、传播、影视、报纸、杂志以及公共关系等。',
				img:require('../../static/images/usmeiyan10.png')
			},
		],
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/us01.png')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>美国简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								美国是一个比较强大，科技发达，人民幸福指数高的国家。 <br/>
								美国在近代史上占有的主导地位快速崛起，成为了相对年轻但又强大到不容置疑的一股力量。在世界格局中扮演重要角色，拥有实力世界第一的军队，生产的产品占据着世界市场的很大份额。</div>
							<img className={'img'} src={require('../../static/images/us02.png')} alt=""/>
						</div>
						<div className={'title'}>
							<span>美国留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.youshi.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>美研十大热门专业介绍</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.zhuanye.map((item,index)=>(
									<CardItem blue={'blue'} item={item} key={index}/>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Usmeiyan